// import React, { useState, useEffect } from 'react'; // Added useEffect
// import { motion, AnimatePresence } from 'framer-motion';
// // Import Toast components
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import {
//   Phone,
//   Mail,
//   MapPin,
//   Send,
//   MessageSquare,
//   Clock,
//   ArrowRight,
//   CheckCircle2,
//   Linkedin,
//   Twitter,
//   Facebook,
//   Instagram,
//   Loader2,
//   RefreshCcw // Added for captcha refresh
// } from 'lucide-react';
// import HERO_IMAGE from "../../assets/contact us.webp"
// import { API_URL } from '../../../Constants';

// // --- Framer Motion Variants ---
// const containerVariants = {
//   hidden: { opacity: 0 },
//   visible: {
//     opacity: 1,
//     transition: { staggerChildren: 0.1, delayChildren: 0.1 }
//   }
// };

// const itemVariants = {
//   hidden: { opacity: 0, y: 15 },
//   visible: {
//     opacity: 1,
//     y: 0,
//     transition: { type: "spring", stiffness: 100, damping: 20 }
//   }
// };

// // --- Helper Components ---
// const InputField = ({ label, type = "text", placeholder, name, value, onChange, required }) => (
//   <div className="flex flex-col space-y-1.5">
//     <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
//     <input
//       type={type}
//       name={name}
//       value={value}
//       onChange={onChange}
//       placeholder={placeholder}
//       required={required}
//       className="w-full px-5 py-3.5 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all duration-300"
//     />
//   </div>
// );

// const TextArea = ({ label, placeholder, name, value, onChange, required }) => (
//   <div className="flex flex-col space-y-1.5">
//     <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
//     <textarea
//       name={name}
//       value={value}
//       onChange={onChange}
//       rows="4"
//       placeholder={placeholder}
//       required={required}
//       className="w-full px-5 py-3.5 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all duration-300 resize-none"
//     />
//   </div>
// );

// const ContactDetail = ({ icon: Icon, title, content, subContent }) => (
//   <motion.div 
//     variants={itemVariants}
//     className="flex items-start gap-3 p-2 rounded-xl hover:bg-white/10 transition-colors duration-300 group cursor-default"
//   >
//     <div className="p-2 bg-white/10 rounded-lg group-hover:bg-[#F46653] transition-colors duration-300 shadow-sm">
//       <Icon className="text-white w-4 h-4" />
//     </div>
//     <div>
//       <h4 className="text-white/60 text-[10px] font-medium uppercase tracking-wider mb-0">{title}</h4>
//       <p className="text-white text-base font-bold leading-tight">{content}</p>
//       {subContent && <p className="text-white/70 text-xs mt-0">{subContent}</p>}
//     </div>
//   </motion.div>
// );

// const EmailContactDetail = () => (
//   <motion.div 
//     variants={itemVariants}
//     className="flex items-start gap-3 p-2 rounded-xl hover:bg-white/10 transition-colors duration-300 group cursor-default"
//   >
//     <div className="p-2 bg-white/10 rounded-lg group-hover:bg-[#F46653] transition-colors duration-300 shadow-sm">
//       <Mail className="text-white w-4 h-4" />
//     </div>
//     <div className="flex-1">
//       <h4 className="text-white/60 text-[10px] font-medium uppercase tracking-wider mb-0">Email Address</h4>
//       <div className="space-y-1">
//         <div><p className="text-white text-base font-bold leading-tight">info@deetyasoft.com</p></div>
//         <div><p className="text-white text-base font-bold leading-tight">support@eurofox.com</p></div>
//       </div>
//     </div>
//   </motion.div>
// );

// export const ContactUs = () => {
//   const [formState, setFormState] = useState({
//     fullName: '', // Changed name to fullName to match API
//     email: '',
//     phoneNumber: '', // Changed phone to phoneNumber to match API
//     subject: '',
//     message: ''
//   });
  
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   // --- CAPTCHA LOGIC ---
//   const [captchaText, setCaptchaText] = useState('');
//   const [userInputCaptcha, setUserInputCaptcha] = useState('');

//   const generateCaptcha = () => {
//     const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789"; // Removed ambiguous chars like 1, I, 0, O
//     let result = "";
//     for (let i = 0; i < 6; i++) {
//       result += chars.charAt(Math.floor(Math.random() * chars.length));
//     }
//     setCaptchaText(result);
//     setUserInputCaptcha('');
//   };

//   useEffect(() => {
//     generateCaptcha();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
    
//     if (name === 'phoneNumber') { // Updated to match state key
//         const cleaned = value.replace(/\D/g, ''); 
//         if (cleaned.length <= 10) {
//             setFormState({ ...formState, [name]: cleaned });
//         }
//         return;
//     }

//     setFormState({ ...formState, [name]: value });
//   };

//   const validateForm = () => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const phoneRegex = /^\d{10}$/;

//     if (!emailRegex.test(formState.email)) {
//       toast.error("Please enter a valid email address with '@'");
//       return false;
//     }
//     if (!phoneRegex.test(formState.phoneNumber)) { // Updated to match state key
//       toast.error("Phone number must be exactly 10 digits");
//       return false;
//     }
//     if (formState.fullName.trim().length < 2) { // Updated to match state key
//       toast.error("Please enter your full name");
//       return false;
//     }
//     // Final check for Captcha
//     if (userInputCaptcha.toUpperCase() !== captchaText) {
//       toast.error("Incorrect security code. Please try again.");
//       generateCaptcha();
//       return false;
//     }
//     return true;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!validateForm()) return;

//     setIsSubmitting(true);

//     try {
//       const response = await fetch (`${API_URL}/api/public/contact`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(formState),
//       });

//       const result = await response.json();

//       if (response.ok && result.success) {
//         setIsSubmitted(true);
//         toast.success(result.message || "Message sent successfully!");
//         setFormState({ fullName: '', email: '', phoneNumber: '', subject: '', message: '' });
//         generateCaptcha(); // Refresh captcha after success
//       } else {
//         toast.error(result.message || "Something went wrong. Please try again.");
//         generateCaptcha();
//       }
//     } catch (error) {
//       console.error("Submission Error:", error);
//       toast.error("Failed to connect to the server.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const bgPuzzleStyle = {
//     backgroundImage: `
//       linear-gradient(#0C4550 1px, transparent 1px),
//       linear-gradient(90deg, #0C4550 1px, transparent 1px)
//     `,
//     backgroundSize: '30px 30px',
//   };

//   return (
//     <div className="font-sans bg-white overflow-hidden">
//       <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} />
      
//       {/* --- HERO SECTION --- */}
//       <section className="relative h-[60vh] w-full overflow-hidden flex items-center justify-center">
//         <div className="absolute inset-0 z-0">
//             <motion.img
//                 initial={{ scale: 1.1 }}
//                 animate={{ scale: 1 }}
//                 transition={{ duration: 10, ease: "easeOut" }}
//                 src={HERO_IMAGE}
//                 alt="Eurofox Office"
//                 className="w-full h-full object-cover"
//             />
//             <div className="absolute inset-0 bg-[#0C4550]/60 mix-blend-multiply" />
//         </div>

//         <div className="relative z-10 container mx-auto px-4 text-center">
//             <motion.div
//                 initial="hidden"
//                 animate="visible"
//                 variants={containerVariants}
//                 className="max-w-4xl mx-auto"
//             >
//                 <motion.div variants={itemVariants} className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md px-4 py-2 rounded-full mb-6 border border-white/20">
//                     <div className="w-2 h-2 bg-[#F46653] rounded-full animate-pulse"></div>
//                     <span className="text-white font-bold text-xs uppercase tracking-widest">We are here to help</span>
//                 </motion.div>

//                 <motion.h1 variants={itemVariants} className="text-5xl md:text-7xl font-extrabold text-white mb-6 tracking-tight drop-shadow-lg">
//                     Let's Start a <br/>
//                     <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#F46653] to-[#ff8c7d]">Conversation</span>
//                 </motion.h1>

//                 <motion.p variants={itemVariants} className="text-lg md:text-xl text-gray-200 max-w-2xl mx-auto leading-relaxed">
//                     Have a question about our bulk SMS services? Need a custom enterprise quote? 
//                     Our team is ready to provide the answers you need.
//                 </motion.p>
//             </motion.div>
//         </div>
//       </section>

//       {/* --- CONTACT DETAILS & FORM SECTION --- */}
//       <section id="contact-start" className="py-16 relative overflow-hidden">
//         <div className="absolute inset-0 z-0" style={bgPuzzleStyle}></div>
//         <div className="absolute inset-0 bg-gradient-to-br from-[#0C4550] via-[#0C4550] to-[#09333c] opacity-95"></div>
        
//         <div className="container mx-auto px-4 relative z-10">
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             viewport={{ once: true, amount: 0.2 }}
//             variants={containerVariants}
//             className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 max-w-6xl mx-auto items-start"
//           >
//             {/* LEFT SIDE */}
//             <motion.div variants={itemVariants} className="space-y-8">
//               <div>
//                 <div className="inline-flex items-center gap-2 mb-2">
//                   <div className="w-2.5 h-2.5 bg-[#F46653] rounded-full"></div>
//                   <span className="text-white/80 font-semibold text-xs uppercase tracking-widest">Get in Touch</span>
//                 </div>
//                 <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">
//                   Reach Out to Our <span className="text-[#F46653]">Team</span>
//                 </h2>
//                 <p className="text-white/70 text-base leading-relaxed">
//                   Our dedicated support team is available 24/7 to assist with your bulk SMS needs.
//                 </p>
//               </div>

//               <div className="space-y-3">
//                 <ContactDetail icon={Phone} title="Phone Support" content="+91-9717055088" subContent="24/7 Support Available" />
//                 <EmailContactDetail />
//                 <ContactDetail icon={MapPin} title="Location" content="Abhay Khand -2, Indirapuram" subContent="Ghaziabad, Uttar Pradesh" />
//                 <ContactDetail icon={Clock} title="Business Hours" content="Mon - Sat: 10AM - 6PM" subContent="24/7 Emergency Support" />
//               </div>

//               <motion.div variants={itemVariants} className="pt-4 border-t border-white/20">
//                 <p className="text-white text-base font-bold mb-2">Connect With Us -</p>
//                 <div className="flex gap-3">
//                   {[
//                     { icon: Linkedin, label: 'LinkedIn' },
//                     { icon: Twitter, label: 'Twitter' },
//                     { icon: Facebook, label: 'Facebook' },
//                     { icon: Instagram, label: 'Instagram' }
//                   ].map((social) => (
//                     <motion.a key={social.label} whileHover={{ y: -3 }} whileTap={{ scale: 0.95 }} href="#" className="p-2 bg-white/10 hover:bg-white/20 rounded-lg transition-all duration-300 group">
//                       <social.icon className="w-4 h-4 text-white group-hover:text-[#F46653] transition-colors" />
//                     </motion.a>
//                   ))}
//                 </div>
//               </motion.div>
//             </motion.div>

//             {/* RIGHT SIDE - FORM */}
//             <motion.div variants={itemVariants}>
//               <div className="bg-white rounded-3xl shadow-2xl p-8">
//                 <AnimatePresence mode="wait">
//                   {isSubmitted ? (
//                     <motion.div key="success" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.9 }} className="text-center py-12">
//                       <CheckCircle2 className="w-20 h-20 text-green-500 mx-auto mb-6" />
//                       <h3 className="text-3xl font-bold text-gray-800 mb-4">Message Sent Successfully!</h3>
//                       <p className="text-gray-600 mb-8">Thank you for contacting us. Our team will get back to you within 2 hours.</p>
//                       <button onClick={() => setIsSubmitted(false)} className="px-8 py-3 bg-[#0C4550] text-white font-semibold rounded-xl hover:bg-[#09333c] transition-colors duration-300">
//                         Send Another Message
//                       </button>
//                     </motion.div>
//                   ) : (
//                     <motion.div key="form" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
//                       <div className="flex items-center gap-3 mb-6">
//                         <div className="p-3 bg-[#0C4550]/10 rounded-xl">
//                           <MessageSquare className="w-6 h-6 text-[#0C4550]" />
//                         </div>
//                         <div>
//                           <p className="text-2xl font-bold text-gray-800">Send Us a Message</p>
//                           <p className="text-gray-500 text-sm">Fill out the form below and we'll respond promptly</p>
//                         </div>
//                       </div>

//                       <form onSubmit={handleSubmit} className="space-y-5">
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//                           <InputField label="Full Name" name="fullName" value={formState.fullName} onChange={handleChange} placeholder="Your Name" required />
//                           <InputField label="Email Address" type="email" name="email" value={formState.email} onChange={handleChange} placeholder="Your Email" required />
//                         </div>
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//                           <InputField label="Phone Number" type="tel" name="phoneNumber" value={formState.phoneNumber} onChange={handleChange} placeholder="10 Digit Number" required />
//                           <InputField label="Subject" name="subject" value={formState.subject} onChange={handleChange} placeholder="Bulk SMS Inquiry" required />
//                         </div>
//                         <TextArea label="Your Message" name="message" value={formState.message} onChange={handleChange} placeholder="Tell us about your requirements..." required />

//                         {/* --- ADDED CAPTCHA FIELD --- */}
//                         <div className="flex flex-col space-y-1.5 pt-2">
//                           <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">Security Check</label>
//                           <div className="flex items-center gap-4">
//                             <div className="flex items-center justify-center bg-gray-100 border-2 border-dashed border-gray-300 rounded-xl px-6 py-3 select-none">
//                               <span className="text-xl font-black tracking-[0.3em] text-[#0C4550] italic line-through decoration-[#F46653]/40">
//                                 {captchaText}
//                               </span>
//                             </div>
//                             <button 
//                               type="button" 
//                               onClick={generateCaptcha} 
//                               className="p-2 hover:bg-gray-100 rounded-full transition-colors"
//                               title="Refresh Code"
//                             >
//                               <RefreshCcw className="w-5 h-5 text-gray-500" />
//                             </button>
//                             <div className="flex-1">
//                               <input
//                                 type="text"
//                                 placeholder="Enter code"
//                                 value={userInputCaptcha}
//                                 onChange={(e) => setUserInputCaptcha(e.target.value.toUpperCase())}
//                                 className="w-full px-5 py-3 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all"
//                                 required
//                               />
//                             </div>
//                           </div>
//                         </div>

//                         <div className="flex items-center justify-between pt-2">
//                           <motion.button
//                             disabled={isSubmitting || userInputCaptcha.length < 6}
//                             whileHover={{ scale: isSubmitting ? 1 : 1.05 }}
//                             whileTap={{ scale: isSubmitting ? 1 : 0.95 }}
//                             type="submit"
//                             className="w-full md:w-auto px-8 py-3.5 bg-gradient-to-r from-[#0C4550] to-[#F46653] text-white font-bold rounded-xl transition-all duration-300 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
//                           >
//                             {isSubmitting ? (
//                               <>Processing... <Loader2 className="w-5 h-5 animate-spin" /></>
//                             ) : (
//                               <>Send Message <Send className="w-5 h-5" /></>
//                             )}
//                           </motion.button>
//                         </div>
//                       </form>
//                     </motion.div>
//                   )}
//                 </AnimatePresence>
//               </div>

//               {/* Stats */}
//               <motion.div variants={itemVariants} className="mt-6 grid grid-cols-3 gap-4">
//                 {[{ val: '98%', label: 'Response Rate' }, { val: '2h', label: 'Avg. Response Time' }, { val: '24/7', label: 'Support Available' }].map((stat, idx) => (
//                     <div key={idx} className="bg-white/10 backdrop-blur-sm rounded-2xl p-3 text-center border border-white/20">
//                         <div className="text-xl font-bold text-white">{stat.val}</div>
//                         <div className="text-white/70 text-xs">{stat.label}</div>
//                     </div>
//                 ))}
//               </motion.div>
//             </motion.div>
//           </motion.div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default ContactUs;



import React, { useState, useEffect } from 'react'; 
import { Link } from 'react-router-dom'; // Added Link import
import { motion, AnimatePresence } from 'framer-motion';
// Import Toast components
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Phone,
  Mail,
  MapPin,
  Send,
  MessageSquare,
  Clock,
  ArrowRight,
  CheckCircle2,
  Linkedin,
  Twitter,
  Facebook,
  Instagram,
  Loader2,
  RefreshCcw 
} from 'lucide-react';
import HERO_IMAGE from "../../assets/contact us.webp"
import { API_URL } from '../../../Constants';

// --- Framer Motion Variants ---
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1, delayChildren: 0.1 }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 15 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", stiffness: 100, damping: 20 }
  }
};

// --- Helper Components ---
const InputField = ({ label, type = "text", placeholder, name, value, onChange, required }) => (
  <div className="flex flex-col space-y-1.5">
    <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      className="w-full px-5 py-3.5 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all duration-300"
    />
  </div>
);

const TextArea = ({ label, placeholder, name, value, onChange, required }) => (
  <div className="flex flex-col space-y-1.5">
    <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
    <textarea
      name={name}
      value={value}
      onChange={onChange}
      rows="4"
      placeholder={placeholder}
      required={required}
      className="w-full px-5 py-3.5 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all duration-300 resize-none"
    />
  </div>
);

const ContactDetail = ({ icon: Icon, title, content, subContent }) => (
  <motion.div 
    variants={itemVariants}
    className="flex items-start gap-3 p-2 rounded-xl hover:bg-white/10 transition-colors duration-300 group cursor-default"
  >
    <div className="p-2 bg-white/10 rounded-lg group-hover:bg-[#F46653] transition-colors duration-300 shadow-sm">
      <Icon className="text-white w-4 h-4" />
    </div>
    <div>
      <h4 className="text-white/60 text-[10px] font-medium uppercase tracking-wider mb-0">{title}</h4>
      <p className="text-white text-base font-bold leading-tight">{content}</p>
      {subContent && <p className="text-white/70 text-xs mt-0">{subContent}</p>}
    </div>
  </motion.div>
);

const EmailContactDetail = () => (
  <motion.div 
    variants={itemVariants}
    className="flex items-start gap-3 p-2 rounded-xl hover:bg-white/10 transition-colors duration-300 group cursor-default"
  >
    <div className="p-2 bg-white/10 rounded-lg group-hover:bg-[#F46653] transition-colors duration-300 shadow-sm">
      <Mail className="text-white w-4 h-4" />
    </div>
    <div className="flex-1">
      <h4 className="text-white/60 text-[10px] font-medium uppercase tracking-wider mb-0">Email Address</h4>
      <div className="space-y-1">
        <div><p className="text-white text-base font-bold leading-tight">info@deetyasoft.com</p></div>
        <div><p className="text-white text-base font-bold leading-tight">support@eurofox.com</p></div>
      </div>
    </div>
  </motion.div>
);

export const ContactUs = () => {
  const [formState, setFormState] = useState({
    fullName: '', 
    email: '',
    phoneNumber: '', 
    subject: '',
    message: ''
  });
  
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [consentGiven, setConsentGiven] = useState(false); // Added consent state

  // --- CAPTCHA LOGIC ---
  const [captchaText, setCaptchaText] = useState('');
  const [userInputCaptcha, setUserInputCaptcha] = useState('');

  const generateCaptcha = () => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789"; 
    let result = "";
    for (let i = 0; i < 6; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptchaText(result);
    setUserInputCaptcha('');
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'phoneNumber') { 
        const cleaned = value.replace(/\D/g, ''); 
        if (cleaned.length <= 10) {
            setFormState({ ...formState, [name]: cleaned });
        }
        return;
    }

    setFormState({ ...formState, [name]: value });
  };

  const validateForm = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;

    if (!emailRegex.test(formState.email)) {
      toast.error("Please enter a valid email address with '@'");
      return false;
    }
    if (!phoneRegex.test(formState.phoneNumber)) { 
      toast.error("Phone number must be exactly 10 digits");
      return false;
    }
    if (formState.fullName.trim().length < 2) { 
      toast.error("Please enter your full name");
      return false;
    }
    if (!consentGiven) { // Final check for Consent
      toast.error("Please agree to the Terms & Conditions and Privacy Policy.");
      return false;
    }
    // Final check for Captcha
    if (userInputCaptcha.toUpperCase() !== captchaText) {
      toast.error("Incorrect security code. Please try again.");
      generateCaptcha();
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    setIsSubmitting(true);

    try {
      const response = await fetch (`${API_URL}/api/public/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formState),
      });

      const result = await response.json();

      if (response.ok && result.success) {
        setIsSubmitted(true);
        toast.success(result.message || "Message sent successfully!");
        setFormState({ fullName: '', email: '', phoneNumber: '', subject: '', message: '' });
        setConsentGiven(false); // Reset consent after success
        generateCaptcha(); 
      } else {
        toast.error(result.message || "Something went wrong. Please try again.");
        generateCaptcha();
      }
    } catch (error) {
      console.error("Submission Error:", error);
      toast.error("Failed to connect to the server.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const bgPuzzleStyle = {
    backgroundImage: `
      linear-gradient(#0C4550 1px, transparent 1px),
      linear-gradient(90deg, #0C4550 1px, transparent 1px)
    `,
    backgroundSize: '30px 30px',
  };

  return (
    <div className="font-sans bg-white overflow-hidden">
      <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} />
      
      {/* --- HERO SECTION --- */}
      <section className="relative h-[60vh] w-full overflow-hidden flex items-center justify-center">
        <div className="absolute inset-0 z-0">
            <motion.img
                initial={{ scale: 1.1 }}
                animate={{ scale: 1 }}
                transition={{ duration: 10, ease: "easeOut" }}
                src={HERO_IMAGE}
                alt="Eurofox Office"
                className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-[#0C4550]/60 mix-blend-multiply" />
        </div>

        <div className="relative z-10 container mx-auto px-4 text-center">
            <motion.div
                initial="hidden"
                animate="visible"
                variants={containerVariants}
                className="max-w-4xl mx-auto"
            >
                <motion.div variants={itemVariants} className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md px-4 py-2 rounded-full mb-6 border border-white/20">
                    <div className="w-2 h-2 bg-[#F46653] rounded-full animate-pulse"></div>
                    <span className="text-white font-bold text-xs uppercase tracking-widest">We are here to help</span>
                </motion.div>

                <motion.h1 variants={itemVariants} className="text-5xl md:text-7xl font-extrabold text-white mb-6 tracking-tight drop-shadow-lg">
                    Let's Start a <br/>
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#F46653] to-[#ff8c7d]">Conversation</span>
                </motion.h1>

                <motion.p variants={itemVariants} className="text-lg md:text-xl text-gray-200 max-w-2xl mx-auto leading-relaxed">
                    Have a question about our bulk SMS services? Need a custom enterprise quote? 
                    Our team is ready to provide the answers you need.
                </motion.p>
            </motion.div>
        </div>
      </section>

      {/* --- CONTACT DETAILS & FORM SECTION --- */}
      <section id="contact-start" className="py-16 relative overflow-hidden">
        <div className="absolute inset-0 z-0" style={bgPuzzleStyle}></div>
        <div className="absolute inset-0 bg-gradient-to-br from-[#0C4550] via-[#0C4550] to-[#09333c] opacity-95"></div>
        
        <div className="container mx-auto px-4 relative z-10">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={containerVariants}
            className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 max-w-6xl mx-auto items-start"
          >
            {/* LEFT SIDE */}
            <motion.div variants={itemVariants} className="space-y-8">
              <div>
                <div className="inline-flex items-center gap-2 mb-2">
                  <div className="w-2.5 h-2.5 bg-[#F46653] rounded-full"></div>
                  <span className="text-white/80 font-semibold text-xs uppercase tracking-widest">Get in Touch</span>
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">
                  Reach Out to Our <span className="text-[#F46653]">Team</span>
                </h2>
                <p className="text-white/70 text-base leading-relaxed">
                  Our dedicated support team is available 24/7 to assist with your bulk SMS needs.
                </p>
              </div>

              <div className="space-y-3">
                <ContactDetail icon={Phone} title="Phone Support" content="+91-9717055088" subContent="24/7 Support Available" />
                <EmailContactDetail />
                <ContactDetail icon={MapPin} title="Location" content="Abhay Khand -2, Indirapuram" subContent="Ghaziabad, Uttar Pradesh" />
                <ContactDetail icon={Clock} title="Business Hours" content="Mon - Sat: 10AM - 6PM" subContent="24/7 Emergency Support" />
              </div>

              <motion.div variants={itemVariants} className="pt-4 border-t border-white/20">
                <p className="text-white text-base font-bold mb-2">Connect With Us -</p>
                <div className="flex gap-3">
                  {[
                    { icon: Linkedin, label: 'LinkedIn' },
                    { icon: Twitter, label: 'Twitter' },
                    { icon: Facebook, label: 'Facebook' },
                    { icon: Instagram, label: 'Instagram' }
                  ].map((social) => (
                    <motion.a key={social.label} whileHover={{ y: -3 }} whileTap={{ scale: 0.95 }} href="#" className="p-2 bg-white/10 hover:bg-white/20 rounded-lg transition-all duration-300 group">
                      <social.icon className="w-4 h-4 text-white group-hover:text-[#F46653] transition-colors" />
                    </motion.a>
                  ))}
                </div>
              </motion.div>
            </motion.div>

            {/* RIGHT SIDE - FORM */}
            <motion.div variants={itemVariants}>
              <div className="bg-white rounded-3xl shadow-2xl p-8">
                <AnimatePresence mode="wait">
                  {isSubmitted ? (
                    <motion.div key="success" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.9 }} className="text-center py-12">
                      <CheckCircle2 className="w-20 h-20 text-green-500 mx-auto mb-6" />
                      <h3 className="text-3xl font-bold text-gray-800 mb-4">Message Sent Successfully!</h3>
                      <p className="text-gray-600 mb-8">Thank you for contacting us. Our team will get back to you within 2 hours.</p>
                      <button onClick={() => setIsSubmitted(false)} className="px-8 py-3 bg-[#0C4550] text-white font-semibold rounded-xl hover:bg-[#09333c] transition-colors duration-300">
                        Send Another Message
                      </button>
                    </motion.div>
                  ) : (
                    <motion.div key="form" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                      <div className="flex items-center gap-3 mb-6">
                        <div className="p-3 bg-[#0C4550]/10 rounded-xl">
                          <MessageSquare className="w-6 h-6 text-[#0C4550]" />
                        </div>
                        <div>
                          <p className="text-2xl font-bold text-gray-800">Send Us a Message</p>
                          <p className="text-gray-500 text-sm">Fill out the form below and we'll respond promptly</p>
                        </div>
                      </div>

                      <form onSubmit={handleSubmit} className="space-y-5">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                          <InputField label="Full Name" name="fullName" value={formState.fullName} onChange={handleChange} placeholder="Your Name" required />
                          <InputField label="Email Address" type="email" name="email" value={formState.email} onChange={handleChange} placeholder="Your Email" required />
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                          <InputField label="Phone Number" type="tel" name="phoneNumber" value={formState.phoneNumber} onChange={handleChange} placeholder="10 Digit Number" required />
                          <InputField label="Subject" name="subject" value={formState.subject} onChange={handleChange} placeholder="Bulk SMS Inquiry" required />
                        </div>
                        <TextArea label="Your Message" name="message" value={formState.message} onChange={handleChange} placeholder="Tell us about your requirements..." required />

                        {/* --- SECURITY CODE / CAPTCHA FIELD --- */}
                        <div className="flex flex-col space-y-1.5 pt-2">
                          <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">Security Check</label>
                          <div className="flex items-center gap-4">
                            <div className="flex items-center justify-center bg-gray-100 border-2 border-dashed border-gray-300 rounded-xl px-6 py-3 select-none">
                              <span className="text-xl font-black tracking-[0.3em] text-[#0C4550] italic line-through decoration-[#F46653]/40">
                                {captchaText}
                              </span>
                            </div>
                            <button 
                              type="button" 
                              onClick={generateCaptcha} 
                              className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                              title="Refresh Code"
                            >
                              <RefreshCcw className="w-5 h-5 text-gray-500" />
                            </button>
                            <div className="flex-1">
                              <input
                                type="text"
                                placeholder="Enter code"
                                value={userInputCaptcha}
                                onChange={(e) => setUserInputCaptcha(e.target.value.toUpperCase())}
                                className="w-full px-5 py-3 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        {/* --- CONSENT CHECKBOX --- */}
                        <div className="flex items-start gap-3 pt-2">
                          <input
                            type="checkbox"
                            id="consent"
                            checked={consentGiven}
                            onChange={(e) => setConsentGiven(e.target.checked)}
                            className="mt-1 min-w-[1rem] w-4 h-4 text-[#0C4550] border-gray-300 rounded focus:ring-[#0C4550] cursor-pointer"
                            required
                          />
                          <label htmlFor="consent" className="text-sm text-gray-600 leading-relaxed cursor-pointer select-none">
                            I agree to the <Link to="/terms-and-conditions" onClick={(e) => e.stopPropagation()} className="text-blue-600 font-semibold hover:underline">Terms & Conditions</Link> and <Link to="/privacy-policy" onClick={(e) => e.stopPropagation()} className="text-blue-600 font-semibold hover:underline">Privacy Policy</Link> and consent to receive communications from <strong>Deetya Soft Private Limited</strong> via SMS, Email, Calls, RCS Messages, and WhatsApp.
                          </label>
                        </div>

                        {/* --- SUBMIT BUTTON --- */}
                        <div className="flex items-center justify-between pt-2">
                          <motion.button 
                            disabled={isSubmitting || userInputCaptcha.length < 6 || !consentGiven} 
                            whileHover={{ scale: (isSubmitting || userInputCaptcha.length < 6 || !consentGiven) ? 1 : 1.02 }} 
                            whileTap={{ scale: (isSubmitting || userInputCaptcha.length < 6 || !consentGiven) ? 1 : 0.98 }} 
                            type="submit" 
                            className="w-full py-3.5 bg-gradient-to-r from-[#0C4550] to-[#F46653] text-white font-bold rounded-xl flex items-center justify-center gap-2 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            {isSubmitting ? (
                              <>Processing... <Loader2 className="w-5 h-5 animate-spin" /></>
                            ) : (
                              <>Send Message <Send className="w-5 h-5" /></>
                            )}
                          </motion.button>
                        </div>
                      </form>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>

              {/* Stats */}
              <motion.div variants={itemVariants} className="mt-6 grid grid-cols-3 gap-4">
                {[{ val: '98%', label: 'Response Rate' }, { val: '2h', label: 'Avg. Response Time' }, { val: '24/7', label: 'Support Available' }].map((stat, idx) => (
                    <div key={idx} className="bg-white/10 backdrop-blur-sm rounded-2xl p-3 text-center border border-white/20">
                        <div className="text-xl font-bold text-white">{stat.val}</div>
                        <div className="text-white/70 text-xs">{stat.label}</div>
                    </div>
                ))}
              </motion.div>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;